import { useGetList } from 'ra-core';

export interface VendorApprover {
    id: string;
    name: string;
}

/**
 * Sales users allowed to review/approve vendors — i.e. whoever's role holds
 * the `manage_procurement` permission (same permission ApproveVendorButton
 * itself is gated on), not the entire sales roster.
 */
export function useVendorApprovers(permissionSlug = 'manage_procurement'): VendorApprover[] {
    const { data: rolePermissions, isPending: rolesPending } = useGetList<{ role_slug: string }>(
        'role_permissions',
        {
            pagination: { page: 1, perPage: 200 },
            filter: { permission_slug: permissionSlug },
        },
    );

    const roleSlugs = [...new Set((rolePermissions ?? []).map((rp) => rp.role_slug))];

    const { data: salesUsers } = useGetList<{ id: number; first_name: string; last_name: string }>(
        'sales',
        {
            pagination: { page: 1, perPage: 200 },
            sort: { field: 'first_name', order: 'ASC' },
            filter: { 'role@in': `(${roleSlugs.join(',')})` },
        },
        { enabled: !rolesPending && roleSlugs.length > 0 },
    );

    if (roleSlugs.length === 0) return [];

    return (salesUsers ?? []).map((s) => {
        const name = [s.first_name, s.last_name].filter(Boolean).join(' ');
        return { id: name, name };
    });
}
